import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  logoColor,
  studentFlowHomeBanner,
  TennisSport,
} from "../../../constant/imagePath";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import Colors from "../../../stories/assets/Colors";
import { BeforeLoginHeader } from "../../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { SearchBar } from "../../../stories/SearchBar/SearchBar";
import { Footer } from "../../../stories/Footer/Footer";
import classes from "./HomePage.module.css";
import HomePageMobile from "./HomePageMobile";
import Fonts from "../../../stories/assets/Fonts";
import { PlayCard } from "../../../stories/PlayCard/PlayCard";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader";

function HomePageDesktop() {
  const [searchData, setSearchData] = useState({
    searchArray: [
      "Tennis",
      "Soccer",
      "Football",
      "Golf",
      "Skating",
      "Baseball",
      "Basketball",
    ],
    locationArray: ["San Diego"],
    ShowShadow: true,
  });
  const [playcard, setPlaycard] = useState([
    {
      icon: TennisSport,
      title: "Title",
      value: "1283 coaches",
      selectedData: "",
      showSelection: false,
      onClick: undefined,
    },
    {
      icon: TennisSport,
      title: "Soccer",
      value: "Coming soon",
      selectedData: "",
      showSelection: false,
      onClick: undefined,
    },
    {
      icon: TennisSport,
      title: "Baseball",
      value: "Coming soon",
      selectedData: "",
      showSelection: false,
      onClick: undefined,
    },
    {
      icon: TennisSport,
      title: "Title",
      value: "1283 coaches",
      selectedData: "",
      showSelection: false,
      onClick: undefined,
    },
    {
      icon: TennisSport,
      title: "Soccer",
      value: "Coming soon",
      selectedData: "",
      showSelection: false,
      onClick: undefined,
    },
    {
      icon: TennisSport,
      title: "Baseball",
      value: "Coming soon",
      selectedData: "",
      showSelection: false,
      onClick: undefined,
    },
    {
      icon: TennisSport,
      title: "Title",
      value: "1283 coaches",
      selectedData: "",
      showSelection: false,
      onClick: undefined,
    },
    {
      icon: TennisSport,
      title: "Soccer",
      value: "Coming soon",
      selectedData: "",
      showSelection: false,
      onClick: undefined,
    },
  ]);
  return (
    <div className={classes.homePage}>
      <section className={classes.heroSection}>
        <Container fluid className={["p-0", classes.mainContainer].join(" ")}>
          <AfterLoginHeader showSearch={false} />
          <div className={[classes.heroContent].join(" ")}>
            <p
              style={{
                ...Fonts.h2,
                color: Colors.neutralShadesOfNero,
                letterSpacing: "-0.5px",
              }}
            >
              GET POWERFUL WORKOUTS WITH PROFESSIONAL COACHES
            </p>
          </div>
        </Container>
      </section>
      <div className={[classes.searchBarDiv]}>
        <SearchBar
          searchArray={searchData?.searchArray}
          locationArray={searchData?.locationArray}
          ShowShadow={searchData?.ShowShadow}
        />
      </div>
      <Container className={["p-0", classes.middleSection].join(" ")}>
        <div>
          <p
            style={{ ...Fonts.h4, color: Colors.neutralShadesOfNero }}
            className={[classes.mb28].join(" ")}
          >
            Explore different sports
          </p>
          <div className={[classes.playCardMainDiv].join(" ")}>
            {playcard?.map((item, i) => {
              return (
                <div className={[classes.playCardDiv].join(" ")}>
                  <PlayCard
                    icon={item.icon}
                    title={item.title}
                    value={item.value}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </Container>
      <Footer className={[classes.containerWidth].join(" ")} />
    </div>
  );
}

const HomePage = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, []);

  return isMobile ? <HomePageMobile /> : <HomePageDesktop />;
};
export default HomePage;
